// @ton/core reads the Node `Buffer` global at module-eval time; browsers have
// none. Imported FIRST (before any @ton/* import) by every lazy wallet/vault
// module that pulls the TON stack, so the polyfill evaluates first without
// forcing the `buffer` package into the boot chunk. No-op where Buffer exists.
import { Buffer } from 'buffer'

if (typeof globalThis.Buffer === 'undefined') {
  globalThis.Buffer = Buffer
}
